import http from "./http";

export const getAllAnalytics =async () => {
  const resp = await http.get("/analytics");
  return resp;
};